import { gsap } from "gsap";

export default function initCursor() {
  const isPresent = document.querySelector(".cursor");
  if (!isPresent) {
    return;
  }

  const cursor = document.querySelector(".cursor");

  const links = document.querySelectorAll("a *, a");

  links.forEach((link) => {
    link.addEventListener("mouseenter", (e) => {
      cursor.classList.add("zoomed");
    });
    link.addEventListener("mouseout", (e) => {
      cursor.classList.remove("zoomed");
    });
  });

  gsap.set(cursor, { xPercent: -50, yPercent: -50 });

  window.addEventListener("mousemove", (e) => {
    gsap.to(cursor, 0.24, { x: e.clientX, y: e.clientY });
  });

  let size = "1";

  var timestamp = 0;
  var mY = 0;
  var mX = 0;

  const moveCursor = (e) => {
    var now = Date.now();
    var currentmY = e.screenY;
    var currentmX = e.screenX;
    var dt = now - timestamp;

    var distanceY = Math.abs(currentmY - mY);
    var speedY = Math.round((distanceY / dt) * 1000);

    var distanceX = Math.abs(currentmX - mX);
    var speedX = Math.round((distanceX / dt) * 1000);

    if (speedY > 1200 || speedX > 2000) {
      cursor.classList.add("cursor-sm");
      // size = "0.6";
    } else {
      cursor.classList.remove("cursor-sm");
      // size = "1";
    }

    mY = currentmY;
    mX = currentmX;
    timestamp = now;

    const mouseY = e.clientY;
    const mouseX = e.clientX;
    // cursor.style.transform = `translate3d(${mouseX}px, ${mouseY}px, 0) scale(${size})`;
    // cursor.style.transform = `scale(${size})`;
  };

  window.addEventListener("mousemove", moveCursor);
}
